export default {
  methods: {
    getLinkToTwentyPage(route) {
      return `${process.env.TWENTY_FRONT_PAGE}/${route}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/link.js